<template>
    <div @click="clickCampaign(campaign)">
        <!-- <img :src="campaign.fullImageUrl" class="card-img-top" />
        <div class="card-body">
            <strong>{{campaign.name}}</strong>
            <div>{{getPointMessage()}}</div>
        </div> -->

        <div class="campaign-item"
             :class="{'disable': disableCampaign()}" >

                <div class="campaign-image">
                    <img src="@/assets/img/icon_cahnel.png" />
                </div>

                <div class="description">
                    <div class="campaign-date">ใช้ได้ถึง: {{toDate(campaign.expireDate)}} </div>
                    <div>{{getCampaignName()}}</div>
                </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"
import Moment from 'moment';
import DatetimeHelper from "../../../helper/DatetimeHelper.js";

export default {
    name: 'CampaignItem',
    props: {
        lbl: Object,
        index: Number,
        campaign: Object
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign
        };
    },
    created: function() {
        console.log("item");
    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function (campaign) {
            if (this.disableCampaign()) {
                return;
            }
             this.$emit('clickCampaign', campaign);
            // if (!campaign.redeemItem) {

            //     var path = '/detail/' + campaign.id;
            //     this.$router.push(path);

            // } else {
            //     if (!campaign.redeemItem.IsUsed) {

            //         this.initialSerialModal(campaign);
            //     } else {
            //         return;
            //     }
            // }
            //GA
            // var path = '/campaign/' + this.campaign.id;
            // this.$router.push(path);
        },
        disableCampaign: function () {
            var date = new Date();
            var datenow = DatetimeHelper.convertDateToTimeStampUnix(date);
            if (this.campaign.redeemItem && this.campaign.redeemItem.IsUsed) {
                return true;
            }
            if (datenow > this.campaign.expireDate) {
                return true;
            }
            return false;
        },
        initialSerialModal: function (campaign) {
            this.serialCampaign = campaign;
            this.serialCampaign.serial = campaign.redeemItem.Serial;
            this.busSerialModal.$emit('showSerialModal', this.serialCampaign);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        toDate: function(campaignDate){
            return Moment.unix(campaignDate).utc().format("DD-MM-YYYY");
        },
        getCampaignName: function () {
            if (this.campaign.name) {
                return this.campaign.name;
            } else {
                return this.campaign.redeemItem.Name;
            }
        }

    },
}
</script>
<style lang="scss">
    // @import "@/style/page/Campaign.scss";
    @import "@/style/base/base.scss";
    @import "@/style/page/Campaign.scss";

    .campaign-item{

        @extend %display-flex-nowrap;
        padding-top: 0px;
        align-self: start;
        justify-content: start;
        img{
            margin-top: 6px;
            width: 41px;
            height: 31px;
        }
    }

    .disable {
        opacity: 0.5;
    }

    .description{
        margin-left: 30px;
        line-height: 1.5;
        font-weight: bold;
    }
</style>
